import Vue from 'vue'

//list of valid commands
const validCommands = [
  'create',
  'popOutOpen',
  'popOutClose',
  'toggleMinimize',
  'setHidden',
  'startUpMode',
  'primaryBg',
  'hidden',
  'startUpPosition',
  'setUser',
  'getUser',
  'postMessage',
  'setLang',
  'setHeader'
]

//list of commands that may be bound to a button
const bindCommands = [
  'popOutOpen',
  'popOutClose',
  'toggleMinimize',
  'setHidden',
  'setUser',
  'getUser',
  'postMessage',
  'setLang',
  'setHeader'
]

//list of commands that may only be ran once during boot
const bootCommands = [
  'create',
  'startUpMode',
  'primaryBg',
  'hidden',
  'startUpPosition',
  'setHidden',
  'setUser',
  'getUser',
  'postMessage',
  'setLang',
  'setHeader'
]

function validateCommand(cmd) {
  if (cmd &&
    typeof cmd == 'string' &&
    validCommands.indexOf(cmd) >= 0
  )
    return true
  return false
}

function processAPI(cmd, ...args) {
  if (validateCommand(cmd) && bindCommands.indexOf(cmd) >= 0) { //do not run boot commands
    API.$emit(cmd, ...args)
  }
  if (bindCommands.indexOf(cmd) >= 0)
    return null
}

// due to asynchronouse nature of components, queues need to be
// throttled for duplicate queues, and categorized, where each
// component can fetch and process assigned queues

let Queue = {}

if (window._SwayChat && window._SwayChat.q) {

  let queue = []
  queue = window._SwayChat.q

  queue.forEach((i) => {

    const cmd = [].shift.apply(i)

    if (!validateCommand(cmd))
      return

    //add santize here

    if (bootCommands.indexOf(cmd) >= 0)
      Queue[cmd] = i ? i : true
    // else
    //   (Queue[cmd] = Queue[cmd] || []).push(i)

  })

}

//Override Queueing function
window._SwayChat = processAPI

export const API = new Vue()

export function pushQueue() {
  let cmd = [].shift.apply(arguments)
  Queue[cmd] = arguments
}

export function fetchQueue(i) {
  return Queue[i]
}
